import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import * as color from '../../config/colors';
import * as background from '../../config/backgroundColor';
import { CommonService } from '../../service/common.service';
import { EChartOption, EChartTitleOption } from 'echarts';
import { ChartOptionService } from '../../service/chart-option.service';
import { ECharts } from 'echarts';


@Injectable({
  providedIn: 'root'
})
export class ProgressPieService {

  constructor(
    private commonService: CommonService,
    private chartOptionService: ChartOptionService
  ) { }

  // 顶部legend变化
  topLegendChange(legendData: any[], optionInit: ECharts) {
    legendData.forEach(e => {
      if (e.checked) {
        optionInit.dispatchAction({
          type: "legendSelect",
          name: e.value
        });
      } else {
        optionInit.dispatchAction({
          type: "legendUnSelect",
          name: e.value
        })
      }
    })
  }

  changeChartTitleDark(component, darkMode) {
    if (darkMode) {
      component.chartTitleColor = color.darkModeTextColor;
      component.cardBgColor = background.darkModeBGColor;
    }
  }

  // 改变颜色
  chartColorsChange(colors: string[], colorList: string[]) {
    colors.length = 0;
    colorList.forEach(e => {
      colors.push(e);
    })
  }

  // 图例的darkMode
  legendDarkMode(legendOption) {
    if (_.isNil(legendOption['textStyle'])) {
      legendOption['textStyle'] = {
        color: color.darkModeTextColor
      };
    } else {
      legendOption['textStyle']['color'] = color.darkModeTextColor;
    }
  }
  // 系列的darkMode
  seriesDarkMode(seriesOption: EChartOption.Series) {
    if (_.isNil(seriesOption['label'])) {
      seriesOption['label'] = {};
    }
    seriesOption['label']['color'] = color.darkModeTextColor;
    seriesOption['label']['rich']['level1']['color'] = color.darkModeTextColor;
    seriesOption['label']['rich']['level2']['color'] = color.darkModeTextColor;
    seriesOption['label']['rich']['level3']['color'] = color.darkModeTextColor;

    seriesOption['data'][1]['itemStyle']['color'] = '#191919';
    seriesOption['data'][1]['emphasis']['itemStyle']['color'] = "#191919";
  }

  buildSeries(chartData: any, seriesList: EChartOption.Series[], pieSeriesOption) {
    seriesList.length = 0;
    if (chartData && chartData.hasOwnProperty('chartData') && chartData.hasOwnProperty('textData')) {

      if (+chartData.chartData.value > +chartData.chartData.total) {
        chartData.chartData.total = chartData.chartData.value
      }

      let revisedValue = chartData.chartData.value * 0.75; // 修正后的值
      let surplus = (+chartData.chartData.total - (+chartData.chartData.value)) * 0.75;  //剩余值
      let whiteSpace = chartData.chartData.total * 0.25;  // 留白的 值


      pieSeriesOption.data[0].value = revisedValue;

      // 判断值 以及 总数是否有空值 以及 0  对空值进行处理
      if (chartData.chartData.value == 0 || chartData.chartData.value == null || chartData.chartData.total == 0 || chartData.chartData.total == null) {
        pieSeriesOption.data[0].value = 0;
        surplus = 3;
        whiteSpace = 1;
      }

      // 判断 值 是否比总数大
      if (surplus < 0) {
        surplus = 0;
      }
      pieSeriesOption.data[1].value = surplus;
      pieSeriesOption.data[2].value = whiteSpace;


      if (chartData.chartData.hasOwnProperty('color')) {
        pieSeriesOption.data[0].itemStyle.color = chartData.chartData.color;
        pieSeriesOption.data[0].emphasis.itemStyle.color = chartData.chartData.color;
      }

      let labelArr = [];
      for (const iterator of chartData.textData) {
        iterator.text = iterator.text == null ? '--' : iterator.text;
        iterator.unit = iterator.unit == null ? '--' : iterator.unit;
        if (iterator.level === 1) {
          labelArr.push(`{level1|${iterator.text}}{unitLeve1|${iterator.unit}}`)
        } else if (iterator.level === 2) {
          labelArr.push(`{level2|${iterator.text}}{unit|${iterator.unit}}`)
        } else if (iterator.level === 3) {
          labelArr.push(`{level3|${iterator.text}}{unit|${iterator.unit}}`)
        }
      }

      pieSeriesOption.label.formatter = labelArr.join('\n');

      seriesList.push(pieSeriesOption);
    }

  }

  getDefaultChartTitle() {
    let title = this.chartOptionService.getDefaultChartTitle();
    title.bottom = 0;
    return title;
  }

  // 背景色的darkMode
  chartBackgroundColorDarkMode(chartOption) {
    chartOption.backgroundColor = background.darkModeBGColor;
  }

  // 文字颜色DarkMode
  colorsDarkMode(chartColor: string[]) {
    chartColor.length = 0;
    color.darkModeColors.forEach(e => chartColor.push(e))
  }

  // 设置图例位置
  setLegendPosition(legendOption, legendPosition: string) {
    let style = this.commonService.changeFontSize();
    switch (legendPosition) {
      case "top":
        legendOption.show = false;
        break;
      case "right":
        legendOption['top'] = '14%';
        legendOption['right'] = 0;
        // legendOption['bottom'] = gridOption.bottom;
        // legendOption['width'] = gridOption.right;
        legendOption['orient'] = "vertical";
        legendOption['pageIcons'] = {
          vertival: [
            "path://M472.064 272.448l-399.232 399.232c-22.08 22.08-22.08 57.792 0 79.872 22.016 22.016 57.792 22.08 79.872 0L512 392.256l359.296 359.296c22.016 22.016 57.792 22.08 79.872 0 22.08-22.08 22.016-57.792 0-79.872L551.936 272.448C529.856 250.432 494.144 250.432 472.064 272.448z",
            "path://M472.064 751.552 72.832 352.32c-22.08-22.08-22.08-57.792 0-79.872 22.016-22.016 57.792-22.08 79.872 0L512 631.744l359.296-359.296c22.016-22.016 57.792-22.08 79.872 0 22.08 22.08 22.016 57.792 0 79.872l-399.232 399.232C529.856 773.568 494.144 773.568 472.064 751.552z"
          ],
        };
        legendOption['textStyle']['padding'] = [2, 0, 0, 0];
        break;
      case "none":
        legendOption.show = false;
        break;
      default:
        // gridOption.bottom = legend.bottomLegendHeight;
        legendOption['top'] = 'bottom';
        break;
    }
  }

  // 获取进度环形图的系列
  getProgressPieSeries() {
    let series = this.chartOptionService.getProgressPieSeries();
    return series;
  }
  // 设置smallMode的padding
  setSmallModePadding(component) {
    component.cardPadding = "0rem";
  }
  // 更改饼图的半径大小
  changeChartRadius(pieSeriesOption, radius) {
    pieSeriesOption.radius = radius;
  }
  // 更改饼图排列方向 (true: 顺时针 false: 逆时针)
  changePieClockWise(clockWise: boolean, pieSeries: EChartOption.SeriesPie) {
    pieSeries.clockwise = clockWise;
  }

  setChartTitle(chartTitle, echartTitle) {
    let style = this.commonService.changeFontSize();
    echartTitle.text = chartTitle;
    echartTitle.show = true;
    echartTitle.textStyle.fontWeight = 500;
    echartTitle.textStyle.fontSize = style.fontSize + 2;
  }

  chartTitleDarkMode(EChartTitleOption) {
    EChartTitleOption.textStyle.color = color.darkTextColor;
  }

  setPieCenter(center, pieSeries: EChartOption.SeriesPie) {
    pieSeries.center = center;
  }
}
